/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import StyledEditProfile from "./StyledEditProfile";
import { Button, Typography } from "@mui/material";
import { Box } from "@mui/system";
import EditBusinessOverview from "./EditBusinessOverview";
import EditConnectSocials from "./EditConnectSocials";
import { fetchSellerProfile } from "../../store/reducers/createProfile/apithunk";
import { useDispatch } from "react-redux";
import EditBrandDetails from "./EditBrandDetails";
import { ToastNotifyError } from "../../components/CommonComponents/Toast/ToastNotify";
import rollbar from "../../rollbarConfig";

const EditProfile = () => {
  const dispatch = useDispatch();
  const [selectedPart, setSelectedPart] = useState("businessOverview");
  const [userData, setUserData] = useState(null);

  // References to child form submit functions
  const businessOverviewRef = useRef();
  const connectSocialsRef = useRef();
  const brandDetailsRef = useRef();

  useEffect(() => {
    getProfile();
  }, [selectedPart]);

  const getProfile = async () => {
    try {
      const res = await dispatch(fetchSellerProfile());
      const { data, status, message } = res.payload;
      if (status) {
        setUserData(data);
      } else {
        ToastNotifyError(message);
      }
    } catch (err) {
      rollbar.error("Error message", err);
      console.error(err);
    }
  };

  const handleSaveChanges = () => {
    switch (selectedPart) {
      case "businessOverview":
        businessOverviewRef.current?.submit();
        break;
      case "connectSocials":
        connectSocialsRef.current?.submit();
        break;
      case "brandDetails":
        brandDetailsRef.current?.submit();
        break;
      default:
        break;
    }
  };

  return (
    <StyledEditProfile>
      <Box className='edit-profile-wrap'>
        <Typography className='edit-profile-header'>Edit profile</Typography>
        <Box className='edit-profile-userinfo-wrap'>
          <Box className='userinfo-dp-wrap'>
            <Box className='dp-picture-box'>
              <img
                src={userData?.brand_image}
                alt='profile-picture'
                className='profile-picture'
              />
            </Box>
            <Box className='userinfo-dp'>
              <Typography className='userinfo-dp-company'>
                {userData?.brand_name}
              </Typography>
              <Typography className='userinfo-dp-email'>
                {userData?.website_link}
              </Typography>
            </Box>
          </Box>
          <Box className='userinfo-info-wrap'>
            <Box className='userinfo-name-wrap'>
              <Typography className='userinfo-name-header'>
                Seller name
              </Typography>
              <Typography className='userinfo-name-body'>
                {userData?.seller_name}
              </Typography>
            </Box>
            <Box className='userinfo-name-wrap'>
              <Typography className='userinfo-name-header'>
                Email Address
              </Typography>
              <Typography className='userinfo-name-body'>
                {userData?.email}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box className='edit-profile-mobile-choose-options'>
          <Box
            className={`mobile-options ${selectedPart === "businessOverview" ? "mobile-selected" : ""}`}
            onClick={() => setSelectedPart("businessOverview")}
          >
            <Typography
              className={`mobile-option-text ${selectedPart === "businessOverview" ? "selected-mobile-text" : ""}`}
            >
              Business overview
            </Typography>
          </Box>
          <Box
            className={`mobile-options ${selectedPart === "connectSocials" ? "mobile-selected" : ""}`}
            onClick={() => setSelectedPart("connectSocials")}
          >
            <Typography
              className={`mobile-option-text ${selectedPart === "connectSocials" ? "selected-mobile-text" : ""}`}
            >
              Connect your socials
            </Typography>
          </Box>
          <Box
            className={`mobile-options ${selectedPart === "brandDetails" ? "mobile-selected" : ""}`}
            onClick={() => setSelectedPart("brandDetails")}
          >
            <Typography
              className={`mobile-option-text ${selectedPart === "brandDetails" ? "selected-mobile-text" : ""}`}
            >
              Brand details
            </Typography>
          </Box>
        </Box>
        <Box className='edit-profile-form-wrap'>
          <Box className='form-part-1'>
            <Box
              className={`form-select-box ${selectedPart === "businessOverview" ? "selected" : ""}`}
              onClick={() => setSelectedPart("businessOverview")}
            >
              <Typography className='form-select-box-header'>
                Business overview
              </Typography>
            </Box>
            <Box
              className={`form-select-box ${selectedPart === "connectSocials" ? "selected" : ""}`}
              onClick={() => setSelectedPart("connectSocials")}
            >
              <Typography className='form-select-box-header'>
                Connect your socials
              </Typography>
            </Box>
            <Box
              className={`form-select-box ${selectedPart === "brandDetails" ? "selected" : ""}`}
              onClick={() => setSelectedPart("brandDetails")}
            >
              <Typography className='form-select-box-header'>
                Brand details
              </Typography>
            </Box>
          </Box>
          <Box className='form-part-2'>
            {selectedPart === "businessOverview" && (
              <EditBusinessOverview
                ref={businessOverviewRef}
                userData={userData}
                getData={() => getProfile()}
              />
            )}
            {selectedPart === "connectSocials" && (
              <EditConnectSocials
                ref={connectSocialsRef}
                userData={userData}
                getData={() => getProfile()}
              />
            )}
            {selectedPart === "brandDetails" && (
              <EditBrandDetails
                ref={brandDetailsRef}
                userData={userData}
                getData={() => getProfile()}
              />
            )}
          </Box>
        </Box>

        <Box className='edit-profile-footer'>
          <Button
            variant='contained'
            color='primary'
            className='submit-btn'
            onClick={handleSaveChanges}
          >
            Save Changes
          </Button>
        </Box>
      </Box>
    </StyledEditProfile>
  );
};

export default EditProfile;
